import { Form as FormikForm, Formik } from 'formik';
import PropTypes from 'prop-types';
import styled from 'styled-components';

import { Box } from '@hivebrite/design-system/Box';
import { Button } from '@hivebrite/design-system/Button';

import useCustomTopicName from 'hb-react/shared/apps/TopicsIndexV2/hooks/useCustomTopicName';
import ErrorFocus from 'hb-react/shared/components/formik/components/ErrorFocus';
import {
  CustomAttribute,
  Textarea,
} from 'hb-react/shared/components/formik/components/inputs';
import RequiredExplanation from 'hb-react/shared/components/formik/components/RequiredExplanation';
import { customAttributesInitialValues } from 'hb-react/shared/components/formik/utils/customAttributes';

const MessageInput = () => (
  <Textarea
    ariaLabel={s__('Accessibility|Message for group approval')}
    minHeight={90}
    name="approval[message]"
  />
);

const MemberRequestForm = ({
  handleSubmitRequest,
  isSubmitting,
  onCancel = () => {},
  requestApproval,
}) => {
  const { custom_attributes: customAttributes, message } = requestApproval;
  const topicName = useCustomTopicName();

  const initialValues = {
    approval: {
      ...customAttributesInitialValues(customAttributes),
      message,
    },
  };

  return (
    <Formik initialValues={initialValues} onSubmit={handleSubmitRequest}>
      {() => (
        <Form>
          <Box flexDirection="column">
            <Box font="h4-regular">
              {s__(
                'Topics|This %{topicName} is private. To access it, please send us a request.',
              ).i__({
                topicName,
              })}
            </Box>
            <Box flexDirection="column" mt={5}>
              {'message' in requestApproval ? (
                <MessageInput />
              ) : (
                <>
                  {customAttributes.map((customAttribute) => {
                    const { id, name } = customAttribute;
                    const inputName = `approval[${name}]`;

                    return (
                      <CustomAttribute
                        key={id}
                        name={inputName}
                        customAttribute={customAttribute}
                      />
                    );
                  })}
                  <RequiredExplanation />
                </>
              )}
            </Box>
            <Box justifyContent="flex-end" mt={3}>
              <Button mr={4} variant="secondary" onClick={onCancel}>
                {__('Cancel')}
              </Button>
              <Button type="submit" isLoading={isSubmitting}>
                {I18n.t('actions.send')}
              </Button>
            </Box>
          </Box>

          <ErrorFocus />
        </Form>
      )}
    </Formik>
  );
};

MemberRequestForm.propTypes = {
  onCancel: PropTypes.func,
};

export default MemberRequestForm;

const Form = styled(FormikForm)`
  width: 100%;
`;
